import React from 'react';
import { useSelector } from 'react-redux';
import Images from '../../../shared/images/Images';
import Modal from '../../../shared/modal/Modal';

const ImagesViewModal = ({ onModalClose }) => {
  const images = useSelector((state) => state.visitImages.visitImages);

  return (
    <Modal
      title={'Фото візиту'}
      onClose={onModalClose}
      body={<Images images={images} fullSize={true} readOnly={true} />}
    />
  );
};

export default ImagesViewModal;
